var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true,"top":true}}]},[_c('b-button',{class:_vm.buttonClass,attrs:{"disabled":_vm.disabled},on:{"click":_vm.buttonClicked}},[_c('i',{class:_vm.iconClass})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }